import { render } from "./MobileCarousellMessageInside.vue?vue&type=template&id=c3c7a45a&scoped=true"
import script from "./MobileCarousellMessageInside.vue?vue&type=script&lang=js"
export * from "./MobileCarousellMessageInside.vue?vue&type=script&lang=js"

import "./MobileCarousellMessageInside.vue?vue&type=style&index=0&id=c3c7a45a&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3c7a45a"]])

export default __exports__